import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { ChartId } from "@/Patient/Models/GrowthCharts/BaseChartModel";

type PlotType = "chronological" | "corrected";

interface GrowthChartsPlotSelectionProps {
    chartId: ChartId;
    checkedPlots: PlotType[];

    onPlotSelectionChanged: (plots: PlotType[]) => void;
}

class GrowthChartsPlotSelectionState {}

class GrowthChartsPlotSelection extends BaseReactComponent<GrowthChartsPlotSelectionProps, GrowthChartsPlotSelectionState> {
    public render(): JSX.Element {
        const idPart = `growth-charts-plot-selection-chart-${this.props.chartId}`;
        const chonologicalInputId = idPart + "-chronological";
        const correctedInputId = idPart + "-corrected";

        const className = "plot-selection__item";

        return (
            <div className="plot-selection">
                <div className={className}>
                    <input
                        type="checkbox"
                        id={chonologicalInputId}
                        data-cy={`growthCharts-plotSelection-${this.props.chartId}-chronological`}
                        checked={this.props.checkedPlots.contains("chronological")}
                        onChange={() => this.handlePlotChanged("chronological")}
                    />
                    <label htmlFor={chonologicalInputId}>
                        {cacheStore.GetString("ChronologicalAgeLabel")}
                    </label>
                </div>
                <div className={`${className} ${className}--blue`}>
                    <input
                        type="checkbox"
                        id={correctedInputId}
                        data-cy={`growthCharts-plotSelection-${this.props.chartId}-corrected`}
                        checked={this.props.checkedPlots.contains("corrected")}
                        onChange={() => this.handlePlotChanged("corrected")}
                    />
                    <label htmlFor={correctedInputId}>
                        {cacheStore.GetString("CorrectedAgeLabel")}
                    </label>
                </div>
            </div>
        );
    }

    private handlePlotChanged(plotType: PlotType): void {
        let plots = [...this.props.checkedPlots];
        const isChecked = plots.contains(plotType);
        if (isChecked)
            plots = plots.filter(p => p !== plotType);
        else
            plots.push(plotType);

        this.props.onPlotSelectionChanged(plots);
    }
}

export { GrowthChartsPlotSelection, PlotType };
